
import {logOff} from '../reducers/userReducer';
import {resetCart} from '../reducers/cartReducer';
import {autoScrollOn} from '../reducers/autoScrollReducer';
import {tryHideModal} from '../reducers/modalReducer';
import {rootPageUri} from '../config/uri';
import {hideKioskWarning} from '../reducers/kioskWarningReducer';
import { pushWithQueryParams } from '../services/uri';

export default function clearSession() {
  return dispatch => {
    dispatch(pushWithQueryParams(rootPageUri));
    dispatch(tryHideModal());
    dispatch(hideKioskWarning());
    dispatch(logOff());
    dispatch(resetCart());
    dispatch(autoScrollOn());
  };
}

export function refresh() {
  return dispatch => {
    dispatch(pushWithQueryParams(rootPageUri));
    dispatch(tryHideModal());
    dispatch(resetCart());
    dispatch(autoScrollOn());
  };
}



// WEBPACK FOOTER //
// ./src/actions/clear-session.js